import React from "react";
import Navbar from "../components/navbar";

function Media(prop)
{
    return(    
        <div className="page">
            <Navbar/>
        </div>
    );
}

export default Media;